import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from '@mui/material';


export default function SpiegoneModalitaPagamento() {
  return (
    <div>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span" color="primary">Come decidere la modalità di pagamento?</Typography>
        </AccordionSummary>
        <AccordionDetails>
         <Typography variant='h5'>Come funzionano le scadenza e gli importi</Typography>
         <Typography variant='h6' sx={{mt:1}}>Data di notifica</Typography>
         <Typography component="span">E' il giorno in cui hai ricevuto il verbale (per posta o consegna diretta).<br/> Tutte le scadenze partono da questa data.<br/> Se l'hai ricevuto il verbale tramite SEND ti consigliamo di visionare la pagina di <Link href='https://notifichedigitali.it/perfezionamento'>perfezionamento delle notifiche</Link> </Typography>
         <Typography variant='h6' sx={{mt:1}}>Pagamento entro 5 giorni</Typography>
         <Typography component="span">Puoi usufruire di uno sconto e pagare l'importo ridotto <br />Esempio: se la data di notifica è arrivata il 14 settembre, hai tempo fino al 19 settembre incluso</Typography>
         <Typography variant='h6' sx={{mt:1}}>Pagamento entro 60 giorni</Typography>
         <Typography component="span">Dopo i 5 giorni, puoi pagare l'importo ordinario fino a 60 giorni dalla notifica. <br /> Esempio con notifica il 14 settembre, dal 20 settembre fino al 19 Novembre</Typography>
         <Typography variant='h6' sx={{mt:1}}>Dopo i 60 giorni</Typography>
         <Typography component="span">Se non paghi entri i 60 giorni, l'importo puoi aumentare per legge</Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}